import styled, { css } from 'styled-components';
import { Form } from '@unform/web';

export const Wrapper = styled(Form)`
  display: flex;
  flex-direction: column;

  > ul {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;

    margin-bottom: 2rem;

    span {
      font-weight: 700;
      margin-right: 1.5rem;
    }
  }

  .MuiFormControl-root {
    margin: 3px 0;
  }

  .MuiFormHelperText-root.Mui-error{
    margin-top:0;
  }
`;

export const WrapperOL = styled.ol`
  ${({ columns }) => css`
    display: grid;
    grid-template-columns: repeat(${columns}, 1fr);

    list-style: none;

    > li {
      border: 1px solid rgba(0, 0, 0, 0.15);
      padding: 0.5rem;

      font-size: 1.3rem;

      span {
        font-weight: 700;
        margin-right: 0.5rem;
      }
    }
  `}
`;

export const WrapperHeading = styled.header`
  padding: 0.5rem;
  margin: 1.5rem 0 0.5rem 0;

  background-color: rgba(0, 0, 0, 0.15);
  color: #666;

  display: flex;
  align-items: center;
  justify-content: center;

  font-weight: 700;
`;

export const SmallWrapperHeading = styled.header`
  padding: 0.5rem;
  margin: 1.5rem 0 0.5rem 0;

  background-color: rgba(0, 0, 0, 0.15);
  color: #666;

  display: flex;
  align-items: center;
  max-width:400px;
  justify-content: center;

  font-weight: 700;
`;

export const SmallWrapperOL = styled.ol`
  ${({ columns }) => css`
    display: grid;
    grid-template-columns: repeat(${columns}, 1fr);
    max-width:400px;

    list-style: none;

    > li {
      border: 1px solid rgba(0, 0, 0, 0.15);
      padding: 0.5rem;

      font-size: 1rem;

      span {
        font-weight: 700;
        margin-right: 0.5rem;
      }
    }
  `}
`;

